// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__vFFLQ","footerItem":"footer_footerItem__RE6zC","boostButton":"footer_boostButton__x5B+A","timer":"footer_timer__dMl4Q"};